<template>
    <v-row align="center" justify="center">
        <v-col cols="12" sm="12" md="12">
            <v-card class="elevation-4">

                <v-card-title>
                    <v-toolbar flat>
                        <v-btn small dark color="primary" @click="dialog = true">
                            <v-icon left>fas fa-plus-square</v-icon>Nuevo usuario
                        </v-btn>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-col cols="12" md="8" sm="4" class="d-flex justify-end">
                        <v-text-field v-model="search" append-icon="fas fa-search" label="Buscar usuario" single-inline hide-details @keydown.enter="searchUser"></v-text-field>
                        <v-btn icon class="mt-4 ml-2" @click="reload()" title="Actualizar">
                            <v-icon dense>fas fa-sync</v-icon>
                        </v-btn>
                        <Columns :headers.sync="headers"></Columns>
                    </v-col>
                </v-card-title>

                <v-card-text>
                <v-data-table dense :headers="filteredHeaders" :items="usuarios" class="elevation-1"
                :loading="loading" :options.sync="options"
                :server-items-length="totalElements" :items-per-page="itemsPerPage"
                :page.sync="page" @page-count="totalPages = $event"
                hide-default-footer>
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-menu bottom offset-x rounded="lg" transition="slide-y-transition" color="primary">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" color="teal darken-1" class="white--text" small>
                                    <v-icon>fas fa-ellipsis-v</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item disabled>
                                    <v-list-item-content>
                                        <v-list-item-subtitle>{{ item.username }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item @click.prevent="editarUsuario(item)" v-if="item.activo">
                                    <v-list-item-title>
                                        <v-icon small>fas fa-edit</v-icon> Editar usuario
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item @click.prevent="lockUser(item)" v-if="item.activo">
                                    <v-list-item-title class="red--text">
                                        <v-icon small class="red--text">fas fa-lock</v-icon> Bloquear usuario
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                    <template v-slot:[`item.eliminado`]="{ item }">
                        <div class="center">
                            <v-chip :color="colorstatus(item.activo)" x-small dark v-text="item.activo ? 'Activo': 'Inactivo'"></v-chip>
                        </div>
                    </template>
                </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <PaginationNumber :itemsPerPage.sync="itemsPerPage" :pageCount.sync="totalPages"
                    :totalElements.sync="totalElements" :page.sync="page" :initialize.sync="initialize" />
                </v-card-actions>

            </v-card>
        </v-col>

        <ModalNuevoUsuario :dialog.sync="dialog" :initialize.sync="initTableUser" :roles="roles" v-if="dialog" :handleModal="handleModal"></ModalNuevoUsuario>
        <ModalEditarUsuario :dialog.sync="dialogEdit" :dataEditUsuario.sync="dataEditUsuario" :initialize.sync="initTableUser" :roles="roles" v-if="dialogEdit" :handleModal="handleEditModal"></ModalEditarUsuario>
    </v-row>
</template>

<script>
import UsuarioDataService from '@/service/usuario/UsuarioDataService'
import ModalNuevoUsuario from './NuevoUsuario.vue';
import ModalEditarUsuario from './EditarUsuario.vue';
import { pagedTableMixin } from '@/mixins/serverTableMixin';
import Columns from '@/components/shared/Columns.vue';
import PaginationNumber from '@/components/shared/PaginationNumber.vue';
import { extractMessage } from '@/helpers/errorHelper';

export default {
    name: 'Usuario',
    mixins: [pagedTableMixin],
    components: { ModalNuevoUsuario, ModalEditarUsuario, Columns, PaginationNumber },
    created() {
        this.fetchTableData();
        this.getRoles();
    },
    data() {
        return {
            roles           : [],
            usuarios        : [],

                
            dialog          : false,
            dialogEdit      : false,
            dataEditUsuario : [],
            jsonUsuario:    [],

            headers: [
                { text: 'Acciones', value: 'actions', sortable: false, groupable: false, show: true },
                { text: 'ID', sortable: false, value: 'id', align: ' d-none', visible: false, groupable: false, show: false },
                { text: 'Usuario', value: 'username', sortable: false, groupable: false, show: true },
                { text: 'Empleado', value: 'empleado.nombreCompleto', sortable: false, groupable: false, show: true },
                { text: 'Correo', value: 'email', sortable: false, groupable: false, show: true },
                { text: 'Rol', value: 'roleName', sortable: false, groupable: false, show: true },
                { text: 'Estatus (g)', value: 'eliminado', sortable: false, groupable: false, show: true },
            ]
        }
    },
    methods: {
        searchUser() {
            this.doSearch();
        },
        fetchTable(params){
            return UsuarioDataService.getAll( params );
        },
        applyRows({ rows, total, totalPages }){
            this.usuarios = rows;
            this.totalElements = total;
            this.totalPages = totalPages;
        },
        // Callback que reciben los diálogos de alta y edición.
        initTableUser(){
            this.reload();
        },
        editarUsuario( item ) {
            UsuarioDataService.jsonUsuario( item.id ).then( resp => {
                this.dataEditUsuario = resp.data;
                this.dataEditUsuario.roleName = resp.data.roleName;
                this.dataEditUsuario.empleadoId = resp.data?.empleado?.id;
                this.dialogEdit = true;
            }).catch( err => {
                this.$swal.fire({ position: 'top-end', title: 'Error', text: extractMessage(err), icon: 'error', showConfirmButton: false, timer: 1500 });
            });
        },
        lockUser( item ) {
            const message = item.empleado?.id 
                ? 'Al bloquear al usuario se desactivará su registro asociado (empleado).'
                : 'Al bloquear al usuario no se podrá revertir la acción.';

            this.$swal.fire({
                title: 'Estas seguro de bloquear el usuario?',
                text: message,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, bloquear usuario!',
                cancelButtonText: 'Cancelar'
            }).then(result => {

                if (result.isConfirmed) {
                    UsuarioDataService.lockUser( item.id ).then( resp => {
                        this.initTableUser();
                        this.$swal.fire({ position: 'top-end', title: 'Bloqueado', text: 'Usuario bloqueado con exito', icon: 'success', showConfirmButton: false, timer: 1500 });
                    }).catch( err => {
                        this.$swal.fire({ position: 'top-end', title: 'Error', text: extractMessage(err), icon: 'error', showConfirmButton: false, timer: 1500 });
                    });
                }

            });
        },
        colorstatus ( status ) { return status ? 'primary' : 'pink'; },
        handleModal() { this.dialog = !this.dialog; },
        handleEditModal() { this.dialogEdit = !this.dialogEdit; },
        async getRoles() {
            this.roles = await UsuarioDataService.getAllRoles().then( resp => resp.data.roles ) || [];
        }
    },

    computed: {
        filteredHeaders() { return this.headers.filter( header => header.show ); }
    }
}
</script>